import { render, staticRenderFns } from "./OtherDecksInSeries.vue?vue&type=template&id=6212e6a1&scoped=true"
import script from "./OtherDecksInSeries.vue?vue&type=script&lang=ts"
export * from "./OtherDecksInSeries.vue?vue&type=script&lang=ts"
import style0 from "./OtherDecksInSeries.vue?vue&type=style&index=0&id=6212e6a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6212e6a1",
  null
  
)

export default component.exports